var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPinpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Pinpoint",
    "data-name": "Controls/icon/Pinpoint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2908",
    "data-name": "Group 2908"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2325",
    "data-name": "Rectangle 2325",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2907",
    "data-name": "Group 2907",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M29.635,11.7A15.15,15.15,0,0,0,19.012,37.5l.029.028,9.731,9.812a1.214,1.214,0,0,0,1.726,0l9.678-9.761c.018-.016.059-.056.076-.074l0,0h0A15.148,15.148,0,0,0,29.635,11.7ZM38.53,35.761h0l-.026.026-8.868,8.941L20.777,35.8c-.012-.013-.023-.026-.035-.036a12.559,12.559,0,1,1,17.788,0Z",
    transform: "translate(-14.635 -11.699)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M29.829,19.846a7.1,7.1,0,1,0,7.047,7.1A7.084,7.084,0,0,0,29.829,19.846Zm0,12.732a5.628,5.628,0,1,1,5.582-5.628A5.612,5.612,0,0,1,29.829,32.578Z",
    transform: "translate(-14.829 -11.827)",
    fill: "#0098db"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinpoint);
export default __webpack_public_path__ + "static/media/Map-Pinpoint.f12592a905a3efcea9276fa1edffc499.svg";
export { ForwardRef as ReactComponent };